import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import bakingApi from '../services/bakingApi';
import './production.css';

export default function ProjectProductionPage() {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    setProject(null); setError('');
    bakingApi.getProject(projectId).then(p => { if (live) setProject(p); }).catch(e => { if (live) setError(e.message); });
    return () => { live = false; };
  }, [projectId]);
  if (error) return <div role="alert" className="error-state">{error}</div>;
  if (!project) return <p role="status">Loading production…</p>;
  const base = `/console/projects/${projectId}`;
  return <div className="production-page">
    <Link to="/console/projects">← Projects</Link>
    <header className="production-header"><div><p className="production-eyebrow">PRODUCTION WORKSPACE</p><h1>{project.name}</h1><p>Every department. One connected production.</p></div><div className="d-flex flex-wrap gap-2"><Link className="btn btn-primary" to={`${base}/files`}>Project Files</Link><Link className="btn btn-outline-secondary" to={`${base}/settings`}>Project Settings</Link></div></header>
    <section className="production-intro"><span className="production-eyebrow">FROM IDEA TO SCREEN</span><h2>Where your production takes shape.</h2><p>Develop characters, shape their stories, and connect the material that brings them to life.</p></section>
    <h2 className="h5 mb-3">Departments</h2>
    <div className="department-grid">
      <Link to={`${base}/departments/character`} className="department-card character"><span className="department-symbol" aria-hidden="true">◎</span><span className="production-eyebrow">01 / DEVELOPMENT</span><h3>Character Department</h3><p>From a first description to visual references and a character ready for production.</p><strong>Explore characters →</strong></Link>
      <Link to={`${base}/departments/story`} className="department-card story"><span className="department-symbol" aria-hidden="true">↝</span><span className="production-eyebrow">02 / NARRATIVE</span><h3>Story Department</h3><p>Build story beats and arcs. Connect them to the characters who carry them.</p><strong>Explore story →</strong></Link>
    </div>
    <p className="production-footnote">Shared references keep characters and stories connected as your production evolves.</p>
  </div>;
}
